/**
 * @generated SignedSource<<f8252b2574f3774d457b89abb74c181d>>
 * @relayHash 395e251011979c6ec0b37576c629adf4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 545f1f224d422f5712e13bc313dd14406919d981e1d3bcbe794dee288fc527cb

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useViewPageRovoActionsGetUserContentQuery$variables = {
  cql: string;
};
export type useViewPageRovoActionsGetUserContentQuery$data = {
  readonly confluence_search: {
    readonly count: number | null | undefined;
  } | null | undefined;
};
export type useViewPageRovoActionsGetUserContentQuery = {
  response: useViewPageRovoActionsGetUserContentQuery$data;
  variables: useViewPageRovoActionsGetUserContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cql"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cql",
        "variableName": "cql"
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 1
      }
    ],
    "concreteType": "ConfluenceSearchConnection",
    "kind": "LinkedField",
    "name": "confluence_search",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "count"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useViewPageRovoActionsGetUserContentQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useViewPageRovoActionsGetUserContentQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "395e251011979c6ec0b37576c629adf4",
    "id": "545f1f224d422f5712e13bc313dd14406919d981e1d3bcbe794dee288fc527cb",
    "metadata": {},
    "name": "useViewPageRovoActionsGetUserContentQuery",
    "operationKind": "query",
    "text": "query useViewPageRovoActionsGetUserContentQuery($cql:String!){confluence_search(cql:$cql,first:1){count}}"
  }
};
})();

(node as any).hash = "31265bf9905142fd23884b73000d4f58";

export default node;
